import React from "react";
import { observer } from "mobx-react";
import { Grid, Typography } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

import { useStore } from "../../store";
import { BackdropPanel } from "../../components";
import { MuiBackdropButton } from "../../components/BackdropPanel/style";
import { setWebBridge } from "../../utils/webBridge";
import { TranslationJSX } from "../../utils/Translation";
import { isAndroid } from "react-device-detect";
import firebaseEvent from "../../utils/firebaseEvent";

const DetailPanelUpdate = () => {
  const {
    detailStore: {
      updateState: { type, isUpdate },
      onUpdateCancel,
    },
  } = useStore();

  if (!isUpdate) return null;

  const bodyLocoKey = () => {
    if (type === "share") return "feed_share_require_update_msg";
    return "feed_version_update_msg";
  };

  const onClickUpdateNow = () => {
    firebaseEvent("detail_app_update", { P1: "update" });
    if (!isAndroid) {
      window.open(
        "https://apps.apple.com/app/kinemaster-video-editor/id1609369954"
      );
    } else {
      return setWebBridge({
        name: "onUpdateApplication",
      });
    }
  };
  const onClickUpdateCancel = () => {
    firebaseEvent("detail_app_update", { P1: "cancel" });
    onUpdateCancel();
  };

  return (
    <BackdropPanel isOpen style={{ zIndex: zIndex.snackbar }}>
      <Typography variant="body2">
        <TranslationJSX locoKey={bodyLocoKey()} />
      </Typography>
      <Grid container spacing={2} justify="center">
        <Grid item>
          <MuiBackdropButton onClick={onClickUpdateCancel}>
            <TranslationJSX locoKey="button_later" />
          </MuiBackdropButton>
        </Grid>
        <Grid item>
          <MuiBackdropButton onClick={onClickUpdateNow}>
            <TranslationJSX locoKey="button_update_now" />
          </MuiBackdropButton>
        </Grid>
      </Grid>
    </BackdropPanel>
  );
};

export default observer(DetailPanelUpdate);
